<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ims-icon slot="icon-only" name="close"></ims-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>{{ peripheral?.displayLabel }}</ion-title>
    <ion-spinner slot="end" *ngIf="configFinished"></ion-spinner>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card *ngIf="!configFinished">
    <img src="{{ currentConfigStep?.image }}" *ngIf="currentConfigStep?.image" />
    <ion-card-header>
      <ion-card-title [innerHTML]="currentConfigStep?.title">
      </ion-card-title>
      <ion-card-subtitle>{{ 'COMPONENT.PERIPHERAL-CONNECTION.STEP' | translate : {cur: (currentStep + 1), total:
        configSteps.length} }}</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content [innerHTML]="currentConfigStep?.description">
    </ion-card-content>

    <ion-button fill="clear" (click)="back()" *ngIf="hasPreviousStep">
      {{ 'COMPONENT.PERIPHERAL-CONNECTION.PREVIOUS' | translate }}
    </ion-button>
    <ion-button fill="clear" (click)="next()" *ngIf="!isLastStep">
      {{ 'COMPONENT.PERIPHERAL-CONNECTION.NEXT' | translate }}
    </ion-button>
    <ion-button fill="clear" (click)="skip()" *ngIf="currentConfigStep?.skip == true">
      {{ 'COMPONENT.PERIPHERAL-CONNECTION.SKIP' | translate }}
    </ion-button>
    <ion-button fill="clear" (click)="action()"
      *ngIf="currentConfigStep?.action != undefined && currentConfigStep?.actionTitle != undefined">
      {{ currentConfigStep.actionTitle }}
    </ion-button>
    <ion-button fill="clear" (click)="finishConfig()" *ngIf="isLastStep">
      {{ 'COMPONENT.PERIPHERAL-CONNECTION.CONNECT' | translate }}
    </ion-button>
  </ion-card>

  <app-data-list *ngIf="configFinished" #list [placeholder]="placeholder" [placeholderTranslate]="true"
    [items]="btDeviceViewModel | async" search="false">
  </app-data-list>

</ion-content>